import { render, staticRenderFns } from "./StampWindow.vue?vue&type=template&id=1c82157d&"
import script from "./StampWindow.vue?vue&type=script&lang=js&"
export * from "./StampWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports